import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useAuthFetch } from "../hooks/useAuthFetch";
import "../stili/PresenzaGaraGenitore.css";


const API_URL = process.env.REACT_APP_API_URL;

export default function PresenzaGaraGenitore() {
  const authFetch = useAuthFetch();
  const navigate = useNavigate();

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [savingIds, setSavingIds] = useState([]);

  useEffect(() => {
  async function fetchPresenzeFuture() {
    setLoading(true);
    try {
      const res = await authFetch(`${API_URL}/api/genitore/presenze-gara/mie/future`);
      if (!res.ok) {
        throw new Error("Errore nel caricamento presenze gara");
      }

      const data = await res.json().catch(() => []);
      const lista = Array.isArray(data)
        ? data.map((item) => ({
            ...item,
            presente: !!item.presente,
            note: item.note || "",
          }))
        : [];

      setItems(lista);
    } catch (err) {
      console.error(err);
      toast.error("Impossibile caricare le convocazioni gara");
    } finally {
      setLoading(false);
    }
  }

  fetchPresenzeFuture();
}, [authFetch]);

  function aggiornaStato(idConvocazioneGiocatore, presente) {
    setItems((prev) =>
      prev.map((item) =>
        item.idConvocazioneGiocatore === idConvocazioneGiocatore
          ? { ...item, presente }
          : item
      )
    );
  }

  function aggiornaNota(idConvocazioneGiocatore, note) {
    setItems((prev) =>
      prev.map((item) =>
        item.idConvocazioneGiocatore === idConvocazioneGiocatore
          ? { ...item, note }
          : item
      )
    );
  }

  async function salvaSingolo(item) {
    const id = item.idConvocazioneGiocatore;
    setSavingIds((prev) => [...prev, id]);

    try {
      const res = await authFetch(`${API_URL}/api/genitore/presenze-gara/${id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          presente: !!item.presente,
          note: item.note || "",
        }),
      });

      if (!res.ok) {
        throw new Error("Errore nel salvataggio");
      }

      const aggiornato = await res.json();

      setItems((prev) =>
        prev.map((riga) =>
          riga.idConvocazioneGiocatore === id
            ? {
                ...aggiornato,
                presente: !!aggiornato.presente,
                note: aggiornato.note || "",
              }
            : riga
        )
      );

      toast.success(`Presenza aggiornata per ${item.cognome} ${item.nome}`);
    } catch (err) {
      console.error(err);
      toast.error("Errore durante il salvataggio della presenza");
    } finally {
      setSavingIds((prev) => prev.filter((x) => x !== id));
    }
  }

  return (
    <div className="sfondo-immagine">
      <div className="presenza-gara-genitore-page">
        <div className="presenza-gara-genitore-container">
          <h2 className="presenza-gara-genitore-title">Presenze Gara</h2>

          {loading ? (
            <div className="presenza-gara-genitore-info-card">
              <p>Caricamento convocazioni...</p>
            </div>
          ) : items.length === 0 ? (
            <div className="presenza-gara-genitore-info-card">
              <p>Nessuna convocazione futura disponibile.</p>
            </div>
          ) : (
            <div className="presenza-gara-genitore-lista">
              {items.map((item) => {
                const saving = savingIds.includes(item.idConvocazioneGiocatore);

                return (
                  <div
                    key={item.idConvocazioneGiocatore}
                    className={`presenza-gara-genitore-card ${
                      item.presente ? "is-presente" : "is-assente"
                    }`}
                  >
                    <div className="presenza-gara-genitore-top">
                      <div>
                        <h3>
                          {item.cognome} {item.nome}
                        </h3>
                        <p>
                          Categoria giocatore:{" "}
                          <strong>{item.categoriaGiocatore || "-"}</strong>
                        </p>
                        <p>
                          Titolare: <strong>{item.titolare ? "Sì" : "No"}</strong>
                        </p>
                      </div>

                      <div className="presenza-gara-genitore-status">
                        <button
                          type="button"
                          className={item.presente ? "toggle-btn active" : "toggle-btn"}
                          onClick={() =>
                            aggiornaStato(item.idConvocazioneGiocatore, true)
                          }
                        >
                          Presente
                        </button>
                        <button
                          type="button"
                          className={!item.presente ? "toggle-btn active" : "toggle-btn"}
                          onClick={() =>
                            aggiornaStato(item.idConvocazioneGiocatore, false)
                          }
                        >
                          Assente
                        </button>
                      </div>
                    </div>

                    <div className="presenza-gara-genitore-info-grid">
                      <div>
                        <span className="label">Evento</span>
                        <strong>{item.nomeEvento || "-"}</strong>
                      </div>
                      <div>
                        <span className="label">Avversario</span>
                        <strong>{item.avversario || "-"}</strong>
                      </div>
                      <div>
                        <span className="label">Data gara</span>
                        <strong>{item.dataGara || "-"}</strong>
                      </div>
                      <div>
                        <span className="label">Ora gara</span>
                        <strong>{item.oraGara ? String(item.oraGara).slice(0, 5) : "-"}</strong>
                      </div>
                      <div>
                        <span className="label">Categoria gara</span>
                        <strong>{item.categoriaGara || "-"}</strong>
                      </div>
                      <div>
                        <span className="label">Ora appuntamento</span>
                        <strong>
                          {item.oraAppuntamento
                            ? String(item.oraAppuntamento).slice(0, 5)
                            : "-"}
                        </strong>
                      </div>
                      <div>
                        <span className="label">Luogo</span>
                        <strong>{item.luogo || "-"}</strong>
                      </div>
                      <div>
                        <span className="label">Indirizzo</span>
                        <strong>{item.indirizzo || "-"}</strong>
                      </div>
                    </div>

                    <div className="presenza-gara-genitore-note-field">
                      <label>Note</label>
                      <textarea
                        value={item.note}
                        onChange={(e) =>
                          aggiornaNota(item.idConvocazioneGiocatore, e.target.value)
                        }
                        rows={2}
                        placeholder="Note facoltative"
                      />
                    </div>

                    <div className="presenza-gara-genitore-card-actions">
  <button
    type="button"
    className="presenza-gara-genitore-btn-primario"
    onClick={() => salvaSingolo(item)}
    disabled={saving}
  >
    {saving ? "Salvataggio..." : "Salva"}
  </button>
</div>
                  </div>
                );
              })}
            </div>
          )}

          <div className="presenza-gara-genitore-actions-final">
  <button
    type="button"
    className="presenza-gara-genitore-btn-secondario"
    onClick={() => navigate(-1)}
  >
    Torna al Gestionale
  </button>
</div>
        </div>
      </div>
    </div>
  );
}